import { Fragment, useEffect, useRef, useState } from "react";
import GuaranteeSeal from "./GuaranteeSeal";
import { asset } from "../../assetUrl";
import "./Template1.css";
import { BRAND_DEFAULT_SVG } from "../../brandDefaultLogo";
import { sanitizeHtml } from "../../sanitizeHtml";

/* ──────────────────────────────────────────────────────────────────────────
   Template 1 — "Light / Inter + sticky enroll sidebar"
   Pixel-exact JSX port of resources/views/fe/courselanding1.blade.php.
   All visual CSS lives in Template1.css scoped under `.clp1-root`. Bootstrap
   (grid + icons) is not loaded in this app, so the grid is reproduced in CSS
   and every `bi bi-*` icon is an inline SVG below.
   ────────────────────────────────────────────────────────────────────────── */

/* ── Inline SVG icons (Bootstrap Icons equivalents) ───────────────────────── */
const Icon = {
  mortarboard: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5ZM8 8.46 1.758 5.965 8 3.052l6.242 2.913L8 8.46Z" />
      <path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Z" />
    </svg>
  ),
  book: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z" />
    </svg>
  ),
  playCircle: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
      <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z" />
    </svg>
  ),
  playCircleFill: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
    </svg>
  ),
  playFill: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
    </svg>
  ),
  fileText: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" />
      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
    </svg>
  ),
  check2: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
    </svg>
  ),
  dot: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
    </svg>
  ),
  chevronDown: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
    </svg>
  ),
  plus: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
    </svg>
  ),
  shieldCheckFill: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path fillRule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z" />
    </svg>
  ),
  shieldCheck: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.30 8.531 1.1 8 1.1c-.531 0-1.552.2-2.662.49zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.379 10.485-.004 7.167.592 2.692A1.54 1.54 0 0 1 1.636 1.43a62.468 62.468 0 0 1 2.887-.87z" />
      <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
    </svg>
  ),
  journalX: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M6.146 6.146a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 0 1 0-.708z" />
      <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" />
      <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" />
    </svg>
  ),
  twitterX: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z" />
    </svg>
  ),
  youtube: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
    </svg>
  ),
  linkedin: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
    </svg>
  ),
  instagram: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
    </svg>
  ),
  facebook: (p) => (
    <svg viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em" {...p}>
      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
    </svg>
  ),
};

/* ── Heading first/second-word accent helper (Blade wraps word index 1). ─── */
function accentWords(text) {
  const words = String(text || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  // Only the 2nd word is accented (matches the Blade). Non-accent words are
  // plain text — NOT wrapped in <span>, so the `.cta-title span` /
  // `.guarantee-title span` green rule applies to the accent word only.
  return words.map((word, i) =>
    i === 1 ? (
      <span key={i} style={{ color: "var(--green)" }}>
        {word}{" "}
      </span>
    ) : (
      <Fragment key={i}>{word} </Fragment>
    )
  );
}

const initials = (name) =>
  String(name || "")
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0].toUpperCase())
    .slice(0, 2)
    .join("");

const Stars = ({ rating, max = 5 }) => {
  const r = Math.round(Number(rating) || 0);
  return Array.from({ length: max }, (_, i) => (i < r ? "★" : "☆")).join("");
};

/* Default brand logo (shown until the creator sets their own) + default course
   cover image. Both are overridden by data when the creator uploads one. */
// Course-landing pages are light-only (no dark: classes anywhere in this
// folder), so the light placeholder is the right one. The old default was
// FlexiLogo.svg — OUR mark, on a CUSTOMER's sales page, which contradicts the
// rule stated on BrandLogo — and it was a 100 KB "SVG" that turned out to be a
// single <rect> filled with a base64 PNG, so it could not be recoloured either.
const DEFAULT_LOGO = BRAND_DEFAULT_SVG;
const DEFAULT_COURSE_IMAGE = asset("/images/course-default.svg");

export default function Template1({ data }) {
  const {
    course = {},
    logo = null,
    header = {},
    skill = {},
    course_include = {},
    prerequisites = {},
    testimonial = {},
    money_back = {},
    faq = {},
    social = {},
    policies = {},
    labels = {},
    video = {},
    video_embed = null,
    modules = [],
    lessonsByModule = {},
    moduleCount = 0,
    lessonCount = 0,
    instructor = null,
    rating = 0,
    members = [],
    memberCount = 0,
    enrollText = "Enroll now",
    enrollLink = "#",
    template_id = 1,
  } = data || {};

  const lbl = (k, d) =>
    String(labels?.[k] || "").trim() !== "" ? labels[k] : d;

  const courseName = course.name || course.title || "";
  const heroTitle =
    String(header.headline || "").trim() !== ""
      ? header.headline
      : courseName;
  const heroSub =
    String(header.sub_headline || "").trim() !== ""
      ? header.sub_headline
      : course.short_description || "";
  // Nav brand logo: creator's logo when set, else the default brand logo.
  const logoImg = String(logo || "").trim() !== "" ? logo : DEFAULT_LOGO;
  // Course cover (hero mockup + enroll card): uploaded image, else default.
  const coverImg = course.funnel_page_image || DEFAULT_COURSE_IMAGE;

  const lessonsFor = (cid) => lessonsByModule?.[String(cid)] || [];
  const lessonsCountFor = (cid) => lessonsFor(cid).length;

  // Guarantee defaults (parity with blade).
  const mbStatus = money_back?.status === undefined ? 1 : money_back.status;
  const mbHeading =
    String(money_back.heading || "").trim() !== ""
      ? money_back.heading
      : "30-Day Risk-Free Money-Back Guarantee";
  const mbDesc =
    String(money_back.description || "").trim() !== ""
      ? money_back.description
      : "We believe in the value of this course and are confident it will help you achieve your goals. That's why we offer a full 30-day risk-free money-back guarantee.<br><br>Go through the content, explore the lessons, and put what you learn into action. If at any point within the first 30 days you feel the course isn't right for you or doesn't meet your expectations, simply reach out to us.<br><br>We'll process your refund promptly—no questions asked.<br><br>There's absolutely no risk in getting started today, only the opportunity to learn, grow, and succeed with complete peace of mind.";

  const headerVisible = header.status === undefined || header.status;

  // The "Course includes" toggle controls the curriculum ("What's inside the
  // course") section. Default ON when never configured; hide only when the
  // creator explicitly turns it off.
  const showCurriculum =
    course_include.status === undefined ? true : !!course_include.status;

  // ── Curriculum accordion state: first module open by default. ──
  const [openModule, setOpenModule] = useState(0);
  // ── FAQ accordion state. ──
  const [openFaq, setOpenFaq] = useState(null);
  // ── Hero video modal state. ──
  const [videoPlaying, setVideoPlaying] = useState(false);
  // ── Footer policy popup state: "privacy" | "terms" | null. ──
  const [openPolicy, setOpenPolicy] = useState(null);
  const hasPrivacy = String(policies?.privacy || "").trim() !== "";
  const hasTerms = String(policies?.terms || "").trim() !== "";
  const iframeSrc = (() => {
    if (!video_embed) return null;
    if ((video.video_type || "") === "other") return video_embed;
    const sep = video_embed.indexOf("?") !== -1 ? "&" : "?";
    return `${video_embed}${sep}enablejsapi=1`;
  })();
  const autoplaySrc = (() => {
    if (!iframeSrc) return null;
    if (iframeSrc.indexOf("autoplay=1") !== -1) return iframeSrc;
    const sep = iframeSrc.indexOf("?") !== -1 ? "&" : "?";
    return `${iframeSrc}${sep}autoplay=1`;
  })();

  // ── Scroll reveal (IntersectionObserver) + scroll progress bar. ──
  const rootRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    root.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

    const onScroll = () => {
      const pct =
        (window.scrollY /
          (document.body.scrollHeight - window.innerHeight)) *
        100;
      setProgress(Number.isFinite(pct) ? pct : 0);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, [data]);

  // Smooth in-page scroll.
  const onAnchorClick = (e, href) => {
    const target = rootRef.current?.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const heroStyle = header.header_bg_image
    ? {
        backgroundImage: `url('${header.header_bg_image}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : undefined;

  const guaranteeStyle = money_back.money_back_bg_image
    ? {
        backgroundImage: `url('${money_back.money_back_bg_image}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : undefined;

  return (
    <div className="clp1-root" ref={rootRef}>
      <div className="clp1-progress-bar" style={{ width: `${progress}%` }} />

      {/* NAVBAR */}
      <nav className="site-nav">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between">
            <a href="#" className="brand" onClick={(e) => e.preventDefault()}>
              <img src={logoImg} className="site-logo" alt="Logo" />
            </a>

            <div className="d-none d-md-flex align-items-center gap-1">
              {moduleCount && showCurriculum ? (
                <a
                  href="#curriculum"
                  className="nav-link-custom"
                  onClick={(e) => onAnchorClick(e, "#curriculum")}
                >
                  {lbl("curriculum", "Curriculum")}
                </a>
              ) : null}

              {instructor && instructor.name ? (
                <a
                  href="#instructor"
                  className="nav-link-custom"
                  onClick={(e) => onAnchorClick(e, "#instructor")}
                >
                  {lbl("instructor", "Instructor")}
                </a>
              ) : null}

              {testimonial?.status && testimonial?.list?.length ? (
                <a
                  href="#reviews"
                  className="nav-link-custom"
                  onClick={(e) => onAnchorClick(e, "#reviews")}
                >
                  {lbl("reviews", "Reviews")}
                </a>
              ) : null}

              {faq?.status && faq?.list?.length ? (
                <a
                  href="#faq"
                  className="nav-link-custom"
                  onClick={(e) => onAnchorClick(e, "#faq")}
                >
                  FAQ
                </a>
              ) : null}
            </div>

            <div className="d-flex align-items-center gap-2">
              <a href={enrollLink} className="btn-nav-enroll btn-text-color">
                <Icon.mortarboard className="me-2" />
                {enrollText}
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero" style={heroStyle}>
        <div className="container">
          <div className="row align-items-end">
            {/* Left: copy */}
            <div className="col-lg-7 hero-content pb-lg-5">
              <h1 className="hero-title fade-up delay-1">
                {accentWords(heroTitle)}
              </h1>

              {heroSub ? (
                <p className="hero-subtitle fade-up delay-2">{heroSub}</p>
              ) : null}

              <div className="hero-actions fade-up delay-3">
                <a href={enrollLink} className="btn-hero-primary btn-text-color">
                  <Icon.mortarboard />
                  {enrollText}
                </a>
              </div>

              <div className="hero-social-proof fade-up delay-4">
                {members.length ? (
                  <>
                    <div className="d-flex align-items-center gap-2">
                      <div className="avatar-stack">
                        {members.map((m, i) =>
                          m.image ? (
                            <img src={m.image} alt={m.name || ""} key={i} />
                          ) : (
                            <div className="av av-1" key={i}>
                              {String(m.name || "?").charAt(0).toUpperCase()}
                            </div>
                          )
                        )}
                      </div>
                      <span className="proof-text">
                        <strong>{memberCount}</strong> {lbl("members", "Members")}
                      </span>
                    </div>
                    <div className="proof-divider" />
                  </>
                ) : null}

                <div className="proof-rating">
                  <span className="stars">
                    <Stars rating={rating} />
                  </span>
                  <span>
                    <strong style={{ color: "rgba(255,255,255,.85)" }}>
                      {Number(rating).toFixed(1)}
                    </strong>{" "}
                    / 5 {lbl("rating", "Rating")}
                  </span>
                </div>
              </div>
            </div>

            {/* Right: mockup */}
            {headerVisible ? (
              <div className="col-lg-5 hero-visual d-none d-lg-block">
                <div className="course-mockup">
                  {video_embed ? (
                    <div
                      className="course-image position-relative"
                      style={{ cursor: "pointer" }}
                    >
                      {!videoPlaying ? (
                        <>
                          <div
                            className="video_thumb"
                            onClick={() => setVideoPlaying(true)}
                          >
                            <img
                              className="w-100"
                              src={video.image || coverImg}
                              alt=""
                            />
                          </div>
                          <div
                            className="video_thumb play-btn position-absolute top-50 start-50 translate-middle"
                            onClick={() => setVideoPlaying(true)}
                          >
                            <Icon.playFill />
                          </div>
                        </>
                      ) : (
                        <div className="video-ifr-box">
                          {(video.video_type || "") === "other" ? (
                            <video controls autoPlay>
                              <source src={video_embed} type="video/mp4" />
                            </video>
                          ) : (
                            <iframe
                              title="course-video"
                              src={autoplaySrc}
                              frameBorder="0"
                              allow="autoplay; fullscreen"
                              allowFullScreen
                            />
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="course-image">
                      <img className="w-100" src={coverImg} alt="" />
                    </div>
                  )}

                  {modules.length ? (
                    <div className="mockup-body">
                      <div className="mockup-modules">
                        {modules.slice(0, 2).map((m) => (
                          <div className="module-row" key={m.course_id}>
                            <div className="module-icon">
                              <Icon.book style={{ color: "var(--green)" }} />
                            </div>
                            <span className="module-title">
                              <a
                                href="#curriculum"
                                onClick={(e) => onAnchorClick(e, "#curriculum")}
                              >
                                {m.course_name}
                              </a>
                            </span>
                            <span className="module-dur">
                              {lessonsCountFor(m.course_id)}{" "}
                              {lbl("lessons", "lessons")}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section>

      {/* MAIN CONTENT + ENROLL SIDEBAR */}
      <div className="container py-5">
        <div className="row g-5">
          {/* Main */}
          <div className="col-lg-8">
            {/* WHAT YOU'LL LEARN */}
            {skill?.status && skill?.list?.length ? (
              <section className="content-section pt-0" id="learn">
                <div className="section-eyebrow reveal">
                  {lbl("what_youll_learn", "What You'll Learn.")}
                </div>
                <h2 className="section-heading mb-4 reveal">
                  {skill.heading || "What you'll learn"}
                </h2>
                <div className="learn-grid reveal">
                  {skill.list.map((s, i) => (
                    <div className="learn-item" key={i}>
                      <Icon.check2 />
                      {s.pts || ""}
                    </div>
                  ))}
                </div>

                {skill.long_desc ? (
                  <div className="skillDesc reveal mt-5">
                    {String(skill.long_desc)
                      .split("\n")
                      .map((line, i, arr) => (
                        <span key={i}>
                          {line}
                          {i < arr.length - 1 ? <br /> : null}
                        </span>
                      ))}
                  </div>
                ) : null}
              </section>
            ) : null}

            {/* "Course includes" is the curriculum section below — its toggle
                (course_include.status) gates that section, not a separate list. */}

            {/* PREREQUISITES */}
            {prerequisites?.status && prerequisites?.list?.length ? (
              <section className="content-section" id="requirements">
                <div className="section-eyebrow reveal">
                  {lbl("prerequisites", "Prerequisites")}
                </div>
                <h2 className="section-heading mb-4 reveal">
                  {prerequisites.heading || "Prerequisites"}
                </h2>
                <div className="learn-grid reveal">
                  {prerequisites.list.map((p, i) => (
                    <div className="learn-item" key={i}>
                      <Icon.dot />
                      {p.pts || ""}
                    </div>
                  ))}
                </div>
              </section>
            ) : null}
          </div>

          {/* Enroll sidebar */}
          <div className="col-lg-4" id="enroll">
            <div className="enroll-card">
              <div className="enroll-card-thumbqq">
                <div className="course-image">
                  <img className="w-100" src={coverImg} alt="" />
                </div>
              </div>
              <div className="enroll-card-body">
                <a href={enrollLink} className="btn-enroll-main btn-text-color">
                  {enrollText}
                </a>

                <div className="enroll-includes">
                  {modules.length ? (
                    <>
                      {modules.slice(0, 4).map((m) => (
                        <div className="include-item" key={m.course_id}>
                          <Icon.check2 /> {m.course_name}
                        </div>
                      ))}

                      {moduleCount > 0 ? (
                        <div className="mt-3 d-flex justify-content-center">
                          <a
                            href="#curriculum"
                            className="view-lessons-btn"
                            onClick={(e) => onAnchorClick(e, "#curriculum")}
                          >
                            {lbl("view_lessons", "View Lessons")}
                          </a>
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </div>
                <div className="guarantee">
                  <Icon.shieldCheckFill />
                  <span>
                    <strong style={{ color: "var(--ink)" }}>
                      {lbl(
                        "money_back_guarantee",
                        "30-Day Money-Back Guarantee."
                      )}
                    </strong>{" "}
                    {lbl(
                      "not_satisfied",
                      "Not satisfied? Full refund, no questions asked."
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CURRICULUM (gated by the "Course includes" toggle) */}
      {moduleCount && showCurriculum ? (
        <section className="curriculum-section" id="curriculum">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-8">
                <div className="section-eyebrow reveal">
                  {lbl("curriculum", "Curriculum")}
                </div>
                <h2 className="section-heading reveal">
                  {lbl("inside_course", "What's inside the course")}
                </h2>
                <p
                  className="reveal mt-2"
                  style={{ fontSize: ".88rem", color: "var(--muted)" }}
                >
                  {moduleCount} {lbl("modules", "modules")} · {lessonCount}{" "}
                  {lbl("lessons", "lessons")}{" "}
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-8">
                {modules.map((m, idx) => {
                  const mls = lessonsFor(m.course_id);
                  const isOpen = openModule === idx;
                  return (
                    <div className="module-card reveal" key={m.course_id}>
                      <button
                        type="button"
                        className={`module-header${isOpen ? "" : " collapsed"}`}
                        aria-expanded={isOpen ? "true" : "false"}
                        onClick={() => setOpenModule(isOpen ? -1 : idx)}
                      >
                        <div className="module-num">{idx + 1}</div>
                        <div className="module-header-title">
                          {m.course_name}
                        </div>
                        <div className="module-header-meta">
                          {mls.length} {lbl("lessons", "Lessons")}
                        </div>
                        <Icon.chevronDown className="module-header-chevron" />
                      </button>

                      {isOpen ? (
                        <div>
                          <div className="module-lessons">
                            {mls.length ? (
                              mls.map((child) => (
                                <div className="lesson-row" key={child.lesson_id}>
                                  {Number(child.lesson_type || 0) === 0 ? (
                                    <Icon.fileText
                                      className="lesson-icon"
                                      style={{ color: "var(--green)" }}
                                    />
                                  ) : (
                                    <Icon.playCircleFill
                                      className="lesson-icon"
                                      style={{ color: "var(--green)" }}
                                    />
                                  )}
                                  <span className="lesson-name">
                                    {String(child.lesson_name || "Lesson").slice(
                                      0,
                                      100
                                    )}
                                  </span>
                                </div>
                              ))
                            ) : (
                              <div className="no-lesson-found">
                                <div className="mb-2">
                                  <Icon.journalX
                                    style={{
                                      fontSize: "1.8rem",
                                      color: "var(--muted)",
                                    }}
                                  />
                                </div>
                                <p
                                  className="mb-0"
                                  style={{
                                    fontSize: ".9rem",
                                    color: "var(--muted)",
                                  }}
                                >
                                  {lbl(
                                    "no_lesson_found",
                                    "No lessons found in this module"
                                  )}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      ) : null}

      {/* INSTRUCTOR */}
      {instructor && instructor.name ? (
        <section className="content-section" id="instructor">
          <div className="container">
            <div className="section-eyebrow reveal">
              {lbl("instructor", "Instructor")}
            </div>
            <h2 className="section-heading mb-4 reveal">
              {lbl("meet_instructor", "Meet the Instructor")}
            </h2>
            <div className="instructor-card reveal">
              <div className="instructor-avatar">
                {instructor.profile_image ? (
                  <img src={instructor.profile_image} alt="Instructor" />
                ) : (
                  initials(instructor.name)
                )}
              </div>
              <div>
                <div className="instructor-name">{instructor.name}</div>
                {instructor.location ? (
                  <div className="instructor-title">{instructor.location}</div>
                ) : null}
                <p className="instructor-bio">
                  {instructor.short_description || ""}
                </p>
              </div>
            </div>
          </div>
        </section>
      ) : null}

      {/* REVIEWS */}
      {testimonial?.status && testimonial?.list?.length ? (
        <section className="reviews-section" id="reviews">
          <div className="container">
            <div className="section-eyebrow reveal">
              {lbl("testimonials", "Testimonials")}
            </div>
            <h2 className="section-heading mb-5 reveal">
              {testimonial.heading || "What students are saying"}
            </h2>

            <div className="row g-4">
              {testimonial.list.map((t, i) => (
                <div className="col-md-6 col-lg-4 reveal" key={i}>
                  <div className="review-card">
                    <div className="review-header">
                      <div className="review-avatar">
                        {t.name
                          ? String(t.name).slice(0, 2).toUpperCase()
                          : "NA"}
                      </div>
                      <div>
                        <div className="review-name">{t.name || ""}</div>
                        <div className="review-role">{t.designation || ""}</div>
                        <div className="review-stars">
                          <Stars rating={t.rating ?? 5} />
                        </div>
                      </div>
                    </div>
                    <p className="review-text">{t.review || ""}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : null}

      {/* GUARANTEE */}
      {mbStatus == 1 ? (
        <section className="guarantee-section" style={guaranteeStyle}>
          <div className="container">
            <div className="guarantee-inner row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <h2 className="guarantee-title fade-up delay-1">
                  {accentWords(mbHeading)}
                </h2>
                <div
                  className="guarantee-sub fade-up delay-2"
                  dangerouslySetInnerHTML={{ __html: mbDesc }}
                />
              </div>

              {/* Right Image */}
              <div className="guarantee-image">
                {money_back.money_back_image ? (
                  <img
                    src={money_back.money_back_image}
                    alt="Guarantee Image"
                    className="img-fluid w-100"
                  />
                ) : (
                  <GuaranteeSeal />
                )}
              </div>
            </div>
          </div>
        </section>
      ) : null}

      {/* FAQ */}
      {faq?.status && faq?.list?.length ? (
        <section className="faq-section" id="faq">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="section-eyebrow reveal">{lbl("faq", "FAQ")}</div>
                <h2 className="section-heading mb-4 reveal">
                  {faq.heading || "Frequently asked questions"}
                </h2>
                {faq.list.map((f, index) => {
                  const isOpen = openFaq === index;
                  return (
                    <div className="faq-item reveal" key={index}>
                      <button
                        className="faq-btn"
                        aria-expanded={isOpen ? "true" : "false"}
                        onClick={() => setOpenFaq(isOpen ? null : index)}
                      >
                        {f.question || ""}
                        <Icon.plus className="faq-icon" />
                      </button>
                      {isOpen ? (
                        <div>
                          <div className="faq-body">{f.answer || ""}</div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      ) : null}

      {/* FINAL CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-inner row align-items-center">
            <div className="col-lg-7 mb-4 mb-lg-0">
              <h2 className="cta-title">{accentWords(heroTitle)}</h2>
              {heroSub ? <p className="cta-sub">{heroSub}</p> : null}
              <a href={enrollLink} className="btn-cta btn-text-color">
                {enrollText}
              </a>
              <div className="cta-note">
                <Icon.shieldCheck className="me-1" />
                {lbl("money_back_guarantee", "30-Day Money-Back Guarantee.") +
                  " " +
                  lbl(
                    "not_satisfied",
                    "Not satisfied? Full refund, no questions asked"
                  )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="site-footer">
        <div className="container">
          <div className="row g-4 mb-2">
            <div className="col-lg-4">
              <div className="social-row">
                {social.x_url ? (
                  <a
                    href={social.x_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <Icon.twitterX />
                  </a>
                ) : null}
                {social.youtube_url ? (
                  <a
                    href={social.youtube_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <Icon.youtube />
                  </a>
                ) : null}
                {social.linkedin_url ? (
                  <a
                    href={social.linkedin_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <Icon.linkedin />
                  </a>
                ) : null}
                {social.instagram_url ? (
                  <a
                    href={social.instagram_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <Icon.instagram />
                  </a>
                ) : null}
                {social.facebook_url ? (
                  <a
                    href={social.facebook_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <Icon.facebook />
                  </a>
                ) : null}
              </div>
            </div>

            <div className="col-lg-8 privacy-container">
              {hasPrivacy || hasTerms ? (
                <div className="footer-links d-flex gap-4 align-items-center">
                  {hasPrivacy ? (
                    <button
                      type="button"
                      className="d-block"
                      onClick={() => setOpenPolicy("privacy")}
                    >
                      {policies.privacy_subject || "Privacy Policy"}
                    </button>
                  ) : null}
                  {hasTerms ? (
                    <button
                      type="button"
                      className="d-block"
                      onClick={() => setOpenPolicy("terms")}
                    >
                      {policies.terms_subject || "Terms"}
                    </button>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </footer>

      {/* POLICY POPUP (Privacy Policy / Terms) */}
      {openPolicy ? (
        <div
          className="clp1-policy-overlay"
          onClick={() => setOpenPolicy(null)}
        >
          <div
            className="clp1-policy-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="clp1-policy-head">
              <h3>
                {openPolicy === "privacy"
                  ? policies.privacy_subject || "Privacy Policy"
                  : policies.terms_subject || "Terms"}
              </h3>
              <button
                type="button"
                aria-label="Close"
                className="clp1-policy-close"
                onClick={() => setOpenPolicy(null)}
              >
                ×
              </button>
            </div>
            <div
              className="clp1-policy-body"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(
                  openPolicy === "privacy"
                    ? policies.privacy
                    : policies.terms),
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
